<template>
  <div class="selected-competitions">
    <loading v-if="loading"></loading>
    <div class="m-container" v-else>

      <div class="header">
        <p>{{ competitions_data[0].name }}</p>
      </div>

      <div class="details">
        <p class="head">Overview</p>
        <p v-html="competitions_data[0].long_description" class="text-details">
        </p>
      </div>

      <!--      <div class="characteristics">
              <p class="head">Regular Category characteristics : </p>
              <div class="age-group">
                <p>Four age groups:</p>
                <ul>
                  <li>WeDo (up to 10y), see more information below</li>
                  <li>WeDo (up to 10y), see more information below</li>
                  <li>WeDo (up to 10y), see more information below</li>
                  <li>WeDo (up to 10y), see more information below</li>
                </ul>
              </div>
            </div>-->

      <div class="this-reqular header">
        <p>Regular Category</p>
      </div>

      <div class="details">
        <p class="text-details">
          The Regular Category is a challenge based competition. Students must design, construct and program their
          robots to solve specific
          challenges on a field. Points are scored for completed tasks.
        </p>
      </div>

      <!-- images -->
      <div class="training-support">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4" v-for="el in competitions_data[0].details" :key="el.id">
            <div class="wro-card sm-padding-bottom">
              <div class="wro-card-content sm-padding-bottom">
                <div class="d-flex align-items-center">
                  <h3>{{ el.title }}</h3>
                </div>

                <div class="text-center">
                  <div class="game-guide-img">
                    <img :src="el.image" alt="">
                  </div>

                  <p class="watch-video" v-if="el.link">
                    <a :href="el.link" target="_blank">Click-Here</a>
                    <span>For more</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- swiper -->
      <!--      <div class="home-slider comp" style="flex-start">
              <div class="w-full ">
                &lt;!&ndash; swiper &ndash;&gt;
                <swiper
                    :options="swiperOption">
                  <swiper-slide
                      v-for="(slideContent, index) in listBackup"
                      :key="index"
                      :virtualIndex="index">
                    <div class="home-slide-row">
                      <div class="col-6" v-for="(img, innerIndex) in slideContent">
                        <img class="" :src="img" alt="banner"/>
                      </div>
                    </div>
                  </swiper-slide>
                  <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
              </div>
            </div>-->

    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading/loading";


export default {
  components: {Loading},
  data: () => ({
    loading: true,
    competitions_data: [],
    list: [],
    listBackup: [],
    swiperOption: {
      direction: 'vertical',
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      slidesPerView: 1,
      /*slidesPerView: 3,
      slidesPerColumn: 2,
      spaceBetween: 30,
      breakpoints: {
        1024: {
          slidesPerView: 3,
          spaceBetween: 40
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 30
        },
        640: {
          slidesPerView: 1,
          spaceBetween: 20
        }
      }*/
    },
  }),
  mounted() {
    this.$API.web.competitions.get_competitions({competition_id: this.$route.params.id})
        .then(response => {
          this.loading = false;
          this.competitions_data = response.data;

          response.data[0].photos.map(el => {
            this.list.push(el.image);
          });

          let that = this;
          let count = 0;
          that.listBackup.push([]);
          this.list.map((el, index) => {
            console.log(el)
            that.listBackup[that.listBackup.length - 1].push(el);
            if ((index + 1) % 4 != 0) {
              count++;
            } else {
              if (index != that.list.length - 1) {
                count = 1;
                that.listBackup.push([])
              }
            }

          })

        })
        .catch(() => {
        });
  }
}
</script>

<style scoped>
.selected-competitions {
  padding: 50px 0;
  min-height: calc(100vh - 148px);
}

p {
  color: #7C7C7C;
}

.head {
  color: var(--mainColors) !important;
  font-size: 24px;
}

.header p {
  font-size: 33px;
  color: var(--mainColors) !important;
}

.header p {
  position: relative;
  width: max-content;
}

.header p:before {
  content: '';
  position: absolute;
  width: 150px;
  height: 2px;
  background: var(--mainColors);
  right: calc(-170px);
  top: 54%;
}

.details {
  margin-bottom: 15px;
}

.details .head {
  font-size: 24px;
  color: #7C7C7C !important;
  margin: 14px 0px !important;
}

.characteristics {
  margin-top: 32px;
}

.characteristics p {
  margin: 14px 0 !important;
}

.characteristics ul {
  margin: 0;
  color: #7C7C7C;
}

.characteristics ul li {
  margin-bottom: 5px;
  font-size: 16px;
}

.age-group p {
  color: #000000 !important;
  font-size: 20px;
  padding-left: 35px;
  width: max-content;
  position: relative;
}

.age-group p:before {
  content: '';
  position: absolute;
  width: 33px;
  height: 2px;
  background: var(--mainColors);
  left: -2%;
  top: 54%;
}

.age-group ul li {
  list-style: disc;
}

.this-reqular {
  margin-top: 45px;
  margin-bottom: 15px;
}

.comp .home-slider {
  align-items: flex-start !important;
}

@media (max-width: 448px) {
  .header p:before {
    width: 50px;
    right: calc(-62px);
  }

}
</style>

<style scoped>


.home-slider .swiper-slide {
  padding-right: 80px;
}

.home-slider .swiper-slide .response {
  width: 100%;
  object-fit: cover;
}


.margin-minus {
  margin-top: -47px !important;
}

.home-slide-row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
}


.home-slide-row .col-6 {
  width: calc((100% / 2) - 30px);
  margin: 0 0 20px;
  padding: 0 10px;
}

.home-slide-row > div {
  overflow: hidden;
}

.home-slide-row .smaller-height {
  height: 220px;
}

.home-slide-row > div {
  height: 267px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.home-slide-row img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.d-flex {
  display: flex;
  flex-wrap: wrap;
}


.fx-width-2 {
  width: 435px !important;
}

.fx-width-2 img {
  width: 100% !important;
}

.h-90 {
  height: 18rem !important;
}
</style>

<style lang="scss" scoped>

/*.carousel-example .swiper-container .swiper-slide {*/
/*  text-align: center;*/
/*  font-size: 38px;*/
/*  font-weight: 700;*/
/*  background-color: #eee;*/
/*  display: -webkit-box;*/
/*  display: -ms-flexbox;*/
/*  display: flex;*/
/*  -webkit-box-pack: center;*/
/*  -ms-flex-pack: center;*/
/*  justify-content: center;*/
/*  -webkit-box-align: center;*/
/*  -ms-flex-align: center;*/
/*  align-items: center;*/
/*  min-height: 300px;*/
/*}*/


#container {
  position: relative;
}

// #Arrow {
//   position: absolute;
//   left: 0;
//   top: 0;
//   bottom: 7%;
//   right: 0;
//   height: 35px !important;
//   width: fit-content !important;
//   margin: auto;
//   padding-bottom: 20px;
// }
#circle {
  position: absolute;
  left: 0;
  top: 380px;
  right: 0;
  margin: auto;
  height: 285px !important;
  width: fit-content !important;
  margin: auto;
  margin-top: -40px;

  @media (max-width: 1200px) {
    top: 85vh !important;
  }
  @media (max-width: 471px) {
    top: 85vh !important;
    width: 100% !important;
  }
}


.home-page .text-content {
  @media (max-width: 1200px) {
    margin-top: 60px !important;
    padding-left: 7rem !important;
    padding-right: 0px !important;
  }
  @media (max-width: 933px) {
    padding-left: 2rem !important;
  }
}


.home-page .img-item {
  object-fit: cover;
  @media (max-width: 933px) {
    display: none;
  }
}


.home-page .first-img-section {
  @media (max-width: 933px) {
    display: none !important;
  }
}

.home-page .img-item-one {
  @media (max-width: 1200px) {
    display: none !important;
  }
}

@media screen and (max-width: 600px) {
  .swiper-wrapper {
    height: 400px;
  }

  .home-slide-row .smaller-height {
    height: 160px;
  }

  .home-slide-row > div {
    height: 207px;
  }

}

.game-guide-img {
  border-bottom: 1px solid #B9B9B9;
  overflow: hidden;
}

.game-guide-img img {
  max-width: 100%;
}
</style>
